// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__mtqVP","row":"styles_row__Vj8ot"};